import { useQuery } from "@tanstack/react-query";
import { getLevelNImagePathWithAPIKey } from "../../../services/b2b-frameworks-apiService";
import { fullImagePath } from "../../b2b-common/helpers";

const useAUEImages = (locale = 'es') => {

    const getImagePath = async (objId, locale) => {
        try {
            const imagePath = await getLevelNImagePathWithAPIKey('generic', 1, objId, locale);
            return fullImagePath(imagePath);
        } catch (error) {
            console.error('Error getting image path for AUE Objective ' + objId + ': ' + error.message);
        }
    };

    const { data: aueImages } = useQuery({
        queryKey: ['aueImages', locale],
        queryFn: async () => {
            const images = {};
            for (let i = 1; i <= 10; i++) {
                images[i] = await getImagePath(i, locale);
            }
            return images;
        }
    });

    return { aueImages };
}

export default useAUEImages;